"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HiddenInput = exports.PasswordInput = exports.EmailInput = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));

var _memoizeFormElement = _interopRequireDefault(require("../../Utilities/memoizeFormElement"));

var _Form = require("../../Form");

var _Validations = require("../../Validations");

var _Elements = require("../../Components/Elements");

var _Components = require("../../Components");

var _Utilities = require("../../Utilities");

var _StyledTypography = require("../../../StyledTypography");

var _ClearInput = _interopRequireDefault(require("../../../../assets/icons/ClearInput.svg"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Input = function Input(_ref) {
  var clearFocusOnEnter = _ref.clearFocusOnEnter,
      name = _ref.name,
      id = _ref.id,
      label = _ref.label,
      type = _ref.type,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      value = _ref.value,
      validations = _ref.validations,
      submitAttempted = _ref.submitAttempted,
      isRequired = _ref.isRequired,
      attr = _ref.attr,
      placeholder = _ref.placeholder,
      clearable = _ref.clearable,
      clear = _ref.clear,
      onClick = _ref.onClick,
      noSpacing = _ref.noSpacing,
      maximumLength = _ref.maximumLength,
      showCharacterCount = _ref.showCharacterCount,
      hideError = _ref.hideError,
      className = _ref.className;
  var errorId = (0, _Utilities.getFormErrorId)(validations, submitAttempted);
  var inputRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react["default"].createElement(_Elements.InputWrapper, {
    className: "".concat(className, " ").concat(errorId ? 'form-error' : '')
  }, /*#__PURE__*/_react["default"].createElement(_Components.Label, {
    label: label,
    name: name,
    id: "".concat(id, "-label"),
    isRequired: isRequired,
    htmlFor: id
  }), /*#__PURE__*/_react["default"].createElement(_Elements.StyledInput, {
    ref: inputRef,
    type: type,
    name: name,
    onKeyDown: function onKeyDown(e) {
      if ((e === null || e === void 0 ? void 0 : e.key) === 'Enter' && clearFocusOnEnter) {
        var _inputRef$current, _inputRef$current$blu;

        // eslint-disable-next-line no-unused-expressions
        inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : (_inputRef$current$blu = _inputRef$current.blur) === null || _inputRef$current$blu === void 0 ? void 0 : _inputRef$current$blu.call(_inputRef$current);
      }
    },
    id: id,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    value: value,
    placeholder: placeholder,
    attr: _objectSpread({
      'aria-labelledby': "".concat(id, "-label"),
      'aria-invalid': errorId ? true : undefined,
      'aria-required': isRequired ? true : undefined,
      maxLength: maximumLength || undefined
    }, attr),
    onClick: onClick
  }), clearable ? /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    className: "clear",
    uniquifyIDs: true,
    cacheRequests: true,
    src: _ClearInput["default"],
    onClick: function onClick() {
      clear({
        name: name
      });
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        clear({
          name: name
        });
        inputRef.current.focus();
      }
    },
    role: "button",
    "aria-label": "Press to clear ".concat(id, "."),
    tabIndex: 0
  }) : null, showCharacterCount && maximumLength && /*#__PURE__*/_react["default"].createElement(_StyledTypography.Caption, {
    textAlign: "right",
    fontColor: "mediumGrey"
  }, value.length, "/", maximumLength), !hideError && /*#__PURE__*/_react["default"].createElement(_Components.ErrorMessage, {
    noSpacing: noSpacing,
    id: errorId,
    values: {
      inputName: label,
      maxLength: maximumLength
    }
  }));
};

Input.Validations = {
  required: _Validations.required,
  maxLength: _Validations.maxLength
};
Input.propTypes = {
  placeholder: _propTypes["default"].string,
  submitAttempted: _propTypes["default"].bool.isRequired,
  validations: _propTypes["default"].object,
  value: _propTypes["default"].string,
  name: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  type: _propTypes["default"].string,
  attr: _propTypes["default"].object,
  isRequired: _propTypes["default"].bool,
  maximumLength: _propTypes["default"].number,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].node]).isRequired,
  clearable: _propTypes["default"].bool,
  clear: _propTypes["default"].func,
  noSpacing: _propTypes["default"].bool,
  showCharacterCount: _propTypes["default"].bool,
  hideError: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  clearFocusOnEnter: _propTypes["default"].bool
};
Input.defaultProps = {
  type: 'text',
  attr: {},
  isRequired: false,
  maximumLength: undefined,
  validations: {},
  placeholder: '',
  clearable: false,
  clear: function clear() {},
  onClick: function onClick() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  noSpacing: false,
  showCharacterCount: false,
  hideError: false,
  className: '',
  clearFocusOnEnter: false
};
var MemoInput = (0, _memoizeFormElement["default"])(Input, ['hideError']);

var _default = (0, _Form.asFormElement)(MemoInput);

exports["default"] = _default;
var EmailInput = (0, _Form.asFormElement)(MemoInput, {
  type: 'email',
  validate: {
    required: true,
    email: true
  }
}, {
  email: _Validations.email
});
exports.EmailInput = EmailInput;
var PasswordInput = (0, _Form.asFormElement)(MemoInput, {
  type: 'password',
  validate: {
    required: true,
    password: true
  }
}, {
  password: _Validations.password
});
exports.PasswordInput = PasswordInput;
var HiddenInput = (0, _Form.asFormElement)(MemoInput, {
  type: 'hidden'
});
exports.HiddenInput = HiddenInput;